<h4 mat-dialog-title>Upload a File to an Acquisition</h4>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <form *ngIf="!acquisition" [formGroup]="newAcqForm" class="form-full-width">
    <mat-form-field style="margin-bottom: 10px">
      <input matInput test-id="new-acqusisition-upload-description" formControlName="label" placeholder="Description">
    </mat-form-field>
    <mat-error *ngIf="newAcqForm.controls.label.touched && newAcqForm.controls.label.errors?.required">
      <small>Acquisition label is required.</small>
    </mat-error>
    <mat-error *ngIf="newAcqForm.controls.label.errors?.maxlength">
      <small>Acquisition label must not exceed {{ acquisitionLabelMaxLength }} characters.</small>
    </mat-error>
    <span style="padding-right: 10px">Timestamp</span>
    <fw-time-field test-id="new-acqusisition-upload-timestamp" formControlName="timestamp"></fw-time-field>
  </form>
  <div *ngIf="acquisition">
    <span test-id="acqusisition-upload-description">Acquisition: {{ acquisition.label }}</span>
  </div>
  <upload-dropzone test-id="acqusisition-upload-dropzone" (afterFilesAdded)="uploadFileList($event)"></upload-dropzone>
  <ul test-id="acqusisition-upload-pending-uploads" class="upload-status-list">
    <li *ngFor="let status of uploadStatus" class="file-status">
      <div class="file-info">
        <div>
          <span class="file-name">{{ status.file.name }}</span>
          <span class="file-size"><strong>{{ status.size[0] }}</strong> {{ status.size[1] }}</span>
        </div>
        <div *ngIf="status.error" class="file-error">{{ status.error }}</div>
      </div>
      <div *ngIf="!processingUploads && status.progress < 100 && !status.error">
        <select class="file-type" [(ngModel)]="status.fileType">
          <option [value]="null">Detect Type Automatically</option>
          <option *ngFor="let fileType of fileTypes" [value]="fileType">{{ fileType }}</option>
        </select>
      </div>
      <div *ngIf="processingUploads && status.progress < 100 && !status.error" class="file-progress">
        <mat-progress-bar mode="determinate" [value]="status.progress" test-id="acquisition-upload-progress"></mat-progress-bar>
      </div>
      <div *ngIf="status.progress === 100" class="file-action">
        <span class="text-success" test-id="acquisition-upload-complete">Success</span>
      </div>
      <div *ngIf="status.error" class="file-action">
        <button mat-stroked-button test-id="acquisition-upload-retry" (click)="retryFile(status)">{{ status.duplicate ? 'Replace' : 'Retry' }}</button>
      </div>
    </li>
  </ul>
  <div mat-dialog-action align="end">
    <ng-container *ngIf="!uploadComplete">
      <button mat-stroked-button (click)="close()" test-id="acquisition-upload-close">Close</button>
      <button mat-flat-button color="primary" test-id="acquisition-upload-submit"
        [disabled]="(!acquisition && newAcqForm.invalid) || uploadStatus.length === 0 || uploadHasErrors"
        (click)="uploadPendingFiles()">Upload</button>
    </ng-container>
    <button mat-flat-button *ngIf="uploadComplete" (click)="close()" color="primary" test-id="acquisition-upload-close">Done</button>
  </div>
</div>
